import img11a from '../assets/home/11a-01-HOME_ST-2011-200x300cm-oleo-sobre-papel.jpg';
import img13a from '../assets/home/13a-01-HOME_Tablas-&-camas-2013-273x176mm-oleo-sobre-revista-National-Geographic-y-madera.png';
import img13b from '../assets/home/13b-01-HOME_Si-vivimos-sera-una-revelacion-2013-200x300cm-oleo-sobre-papel.jpg';
import img13c from '../assets/home/13c-01-HOME_Si-vivimos-sera-una-revelacion-2013-130x90cm_oleo-sobre-papel.jpg';
import img13d from '../assets/home/13d-01-HOME_Esperanza-y-terror-2013-405x295mm-oleo-sobre-papel.jpg';
import img14a from '../assets/home/14a-01-HOME_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img14b from '../assets/home/14b-01-HOME-insolada.jpg';
import img15a from '../assets/home/15a-01-HOME_ST-2015-405x295mm-oleo-sobre-papel.jpg';
import img15b from '../assets/home/15b-01-HOME_Serie-blanca-1-2015-200x300cm-oleo-sobre-papel.jpg';
import img15c from '../assets/home/15c-01-HOME_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img15d from '../assets/home/15d-01-HOME_ST-9-2015-1524x3048mm-oleo-sobre-madera.jpg';
import img15e from '../assets/home/15e-01-HOME_ST-3-2015-1829x1372mm-oleo-sobre-madera.jpg';
import img15f from '../assets/home/15f-01-HOME_Vista-de-exhibicion_Inscripción-en-la-Tierra.jpg';
import img16a from '../assets/home/16a-01-HOME_Camouflage2-2016-1524x3048mm-oleo-sobre-madera.jpg';
import img16b from '../assets/home/16b-01-HOME_SG-2016-125x95cm-oleo-sobre-papel.jpg';
import img16c from '../assets/home/16c-01-HOME_Pasaje-3-2016-405x295mm-oleo-sobre-papel.jpg';
import img16d from '../assets/home/16d-01-HOME_vista.jpg';
import img16e from '../assets/home/16e-01-HOME_Chapas-2-2016-415x29mm-lapiz-portaminas-HB-sobre-papel-70gr.png';
import img17a from '../assets/home/17a-01-HOME_ST-2017-280x350cm-oleo-sobre-madera.jpg';
import img17b from '../assets/home/17b-01-HOME_ST-2017-200x300cm-oleo-sobre-madera.jpg';
import img17c from '../assets/home/17c-01-HOME_Variaciones-2017-200x150cm-oleo-sobre-madera.jpg';
import img17d from '../assets/home/17d-01.jpg';
import img17e from '../assets/home/17e-01-HOME_Los-Angeles-Steve-Turner.jpg';
import img18a from '../assets/home/18a-01-HOME_ST-2018-199x133cm-oleo-sobre-tela.jpg';
import img18b from '../assets/home/18b-01-HOME_movil.jpg';
import img18c from '../assets/home/18c-01-HOME_barro.jpg';
import img18c2 from '../assets/home/18c-06-HOME_ST-2018-200x300cm-oleo-sobre-madera.jpg';
import img19a from '../assets/home/19a-01-HOME_Variaciones-e-improvisaciones-2019-200x179cm-oleo-sobre-madera.jpg';
import img20a from '../assets/home/20a-01-HOME_a.jpg';
import img20b from '../assets/home/20b-01-HOME_ST-2020-426x464mm-oleo-sobre-madera.jpg';
import img20c from '../assets/home/20c-01-HOME_ST-2020-1595x203mm-oleo-sobre-madera.jpg';
import img20d from '../assets/home/20d-01-HOME_ST-2020-1553x1335mm-oleo-sobre-tela.jpg';
import img20e from '../assets/home/20e-01-HOME_ST-2020-188x135cm-oleo-sobre-tela.jpg';
import img21a from '../assets/home/21a-01-HOME_JoaquinBoz_taller.jpg';
import img21b from '../assets/home/21b-01-HOME_ST-2021-188x2375mm-oleo-sobre-tela.jpg';
import img21c from '../assets/home/21c-01-HOME_ST-2021-35x47cm-oleo-sobre-madera.jpg';
import img21d from '../assets/home/20d-01-HOME_ST-2020-1553x1335mm-oleo-sobre-tela.jpg';



export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img11a,
    description: "2011",
    orientation: "h",
    path: "/gallery/11"
  },
  {
    id: 2,
    title: "",
    dimensions: "27,3 x 17,6 cm",
    pictureSrc: img13a,
    description: "2013",
    orientation: "v",
    path: "/gallery/13a"
  },
  {
    id: 3,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img13b,
    description: "2013",
    orientation: "h",
    path: "/gallery/13b"
  },
  {
    id: 4,
    title: "",
    dimensions: "130 x 90 cm",
    pictureSrc: img13c,
    description: "2013",
    orientation: "v",
    path: "/gallery/13c"
  },
  {
    id: 5,
    title: "",
    dimensions: "40,4 x 29,5 cm",
    pictureSrc: img13d,
    description: "2013",
    orientation: "v",
    path: "/gallery/13d"
  },
  {
    id: 6,
    title: "",
    dimensions: "130 x 95 cm",
    pictureSrc: img14a,
    description: "2014",
    orientation: "v",
    path: "/gallery/14a"
  },
  {
    id: 7,
    title: "vista de sala",
    dimensions: "insolada",
    pictureSrc: img14b,
    description: "2014",
    orientation: "h",
    path: "/gallery/14b"
  },
  {
    id: 8,
    title: "",
    dimensions: "40,5 x 29,5 cm",
    pictureSrc: img15a,
    description: "2015",
    orientation: "v",
    path: "/gallery/15a"
  },
  {
    id: 9,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img15b,
    description: "2015",
    orientation: "h",
    path: "/gallery/15b"
  },
  {
    id: 10,
    title: "",
    dimensions: "126 x 95 cm",
    pictureSrc: img15c,
    description: "2015",
    orientation: "v",
    path: "/gallery/15c"
  },
  {
    id: 12,
    title: "",
    dimensions: "152,4 x 304,8 cm",
    pictureSrc: img15d,
    description: "2015",
    orientation: "h",
    path: "/gallery/15d"
  },
  {
    id: 13,
    title: "vista de sala",
    dimensions: "",
    pictureSrc: img15f,
    description: "2015",
    orientation: "h",
    path: "/gallery/15f"
  },
  {
    id: 14,
    title: "",
    dimensions: "182.9 x 137,2 cm",
    pictureSrc: img15e,
    description: "2015",
    orientation: "v",
    path: "/gallery/15e"
  },
  {
    id: 15,
    title: "",
    dimensions: "152.4 x 304,8 cm",
    pictureSrc: img16a,
    description: "2016",
    orientation: "h",
    path: "/gallery/16a"
  },{
    id: 16,
    title: "",
    dimensions: "125 x 95 cm",
    pictureSrc: img16b,
    description: "2016",
    orientation: "v",
    path: "/gallery/16b"
  },{
    id: 17,
    title: "",
    dimensions: "40.5 x 29,5 cm",
    pictureSrc: img16c,
    description: "2016",
    orientation: "v",
    path: "/gallery/16c"
  },{
    id: 18,
    title: "vista de sala",
    dimensions: "",
    pictureSrc: img16d,
    description: "2016",
    orientation: "h",
    path: "/gallery/16d"
  },{
    id: 19,
    title: "",
    dimensions: "41.5 x 29 cm",
    pictureSrc: img16e,
    description: "2016",
    orientation: "v",
    path: "/gallery/16e"
  },
  {
    id: 20,
    title: "",
    dimensions: "280 x 350 cm",
    pictureSrc: img17a,
    description: "2017",
    orientation: "h",
    path: "/gallery/17a"
  },{
    id: 21,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img17b,
    description: "2017",
    orientation: "h",
    path: "/gallery/17b"
  },{
    id: 22,
    title: "",
    dimensions: "200 x 150 cm",
    pictureSrc: img17c,
    description: "2017",
    orientation: "v",
    path: "/gallery/17c"
  },{
    id: 23,
    title: "",
    dimensions: "",
    pictureSrc: img17d,
    description: "2017",
    orientation: "h",
    path: "/gallery/17d"
  },{
    id: 24,
    title: "",
    dimensions: "",
    pictureSrc: img17e,
    description: "2017",
    orientation: "h"
  },{
    id: 25,
    title: "",
    dimensions: "199 x 133 cm",
    pictureSrc: img18a,
    description: "2018",
    orientation: "v",
    path: "/gallery/18a"
  },{
    id: 26,
    title: "",
    dimensions: "",
    pictureSrc: img18b,
    description: "2018",
    orientation: "v",
    path: "/gallery/18b"
  },{
    id: 27,
    title: "",
    dimensions: "",
    pictureSrc: img18c,
    description: "2018",
    orientation: "h",
    path: "/gallery/18c"
  },{
    id: 28,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img18c2,
    description: "2018",
    orientation: "h",
    path: "/gallery/18c"
  },{
    id: 29,
    title: "",
    dimensions: "200 x 179 cm",
    pictureSrc: img19a,
    description: "2019",
    orientation: "v",
    path: "/gallery/19a"
  },{
    id: 30,
    title: "",
    dimensions: "",
    pictureSrc: img20a,
    description: "2020",
    orientation: "h",
    path: "/gallery/20a"
  },{
    id: 31,
    title: "",
    dimensions: "42,6 x 46.4 cm",
    pictureSrc: img20b,
    description: "2020",
    orientation: "h",
    path: "/gallery/20b"
  },{
    id: 32,
    title: "",
    dimensions: "159.5 x 203 cm",
    pictureSrc: img20c,
    description: "2020",
    orientation: "h",
    path: "/gallery/20c"
  },{
    id: 33,
    title: "",
    dimensions: "155.3 x 133,5 cm",
    pictureSrc: img20d,
    description: "2020",
    orientation: "v",
    path: "/gallery/20d"
  },{
    id: 34,
    title: "",
    dimensions: "188 x 135 cm",
    pictureSrc: img20e,
    description: "2020",
    orientation: "v",
    path: "/gallery/20e"
  },{
    id: 35,
    title: "taller",
    dimensions: "",
    pictureSrc: img21a,
    description: "2021",
    orientation: "h",
    path: "/gallery/21a"
  },{
    id: 36,
    title: "",
    dimensions: "188 x 237,5 cm",
    pictureSrc: img21b,
    description: "2021",
    orientation: "h",
    path: "/gallery/21b"
  },{
    id: 37,
    title: "",
    dimensions: "35 x 47 cm",
    pictureSrc: img21c,
    description: "2021",
    path: "/gallery/21c"
  },{
    id: 38,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img21d,
    description: "2021",
    path: "/gallery/21d"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];



// WEBPACK FOOTER //
// ./src/data/data.js